<div class="login-container">
    <!-- Loader Central Moderno -->
    <div class="modern-loader" *ngIf="carregando">
        <div class="loader-rings">
            <div class="loader-ring"></div>
            <div class="loader-ring"></div>
            <div class="loader-ring"></div>
        </div>
        <div class="loader-title">DIVIPREV</div>
    </div>

    <div class="glass-card" *ngIf="emManutencao=='sim' && !carregando">
        <i class="pi pi-exclamation-triangle" style="font-size: 4rem; color: #F58634; margin-bottom: 1.5rem;"></i>
        <h2 class="title" style="background: none; -webkit-text-fill-color: white; font-size: 1.5rem;">Sistema em Manutenção</h2>
        <p class="subtitle" style="margin-bottom: 1rem;">Voltaremos em breve.</p>
        <p class="version" style="margin-top: 1rem;">Versão: {{est.getVersao()}}</p>
    </div>
    
    <!-- Container Animado (Apenas se não estiver carregando e não em manutenção) -->
    <div class="card-flipper" [class.flipped]="exibirProblemas" *ngIf="emManutencao=='nao' && !carregando">
        
        <!-- Frente: Login -->
        <div class="glass-card card-front">
            <div class="title" style="user-select: none;" (click)="contarCliqueSegredo()">Diviprev</div>
            <div class="subtitle">Bem-vindo(a) ao Censo Digital!</div>
            
            <span class="input-label">CPF</span>
            <input pInputText [(ngModel)]="cpf" appMascara="cpf">
            
            <span class="input-label">Data de Nascimento</span>
            <input pInputText [(ngModel)]="nascimento" appMascara="data" (keyup)="atalhoLogin($event)">

            <button class="login-btn" (click)="processar()">Entrar no Sistema <i class="pi pi-arrow-right" style="margin-left: 8px; font-size: 0.9em;"></i></button>
            
            <div class="help-text" (click)="abrirContatoDiviprev()">Estou com problemas para acessar</div>

            <!-- Teste do serviço de WhatsApp: liberado pelo segredo (10 cliques em "Diviprev" + tecla T) -->
            <button class="dev-btn" *ngIf="testeZapLiberado" (click)="abrirTesteZap()">
                <i class="pi pi-whatsapp" style="margin-right: 8px;"></i> Testar envio de WhatsApp
            </button>

            <div class="version">Versão: {{est.getVersao()}}</div>
        </div>

        <!-- Verso: Suporte -->
        <div class="glass-card card-back">
            <div class="back-link" (click)="fecharProblemas()">
                <i class="pi pi-arrow-left"></i> Voltar ao Login
            </div>
            
            <div class="title" style="font-size: 1.5rem; margin-bottom: 2rem;">Suporte Diviprev</div>
            
            <div class="p-grid" style="text-align: left;">
                <div class="p-col-12 p-md-6">
                    <span class="input-label" style="margin-top: 0;">Nome Completo</span>
                    <input type="text" pInputText [(ngModel)]="item.nome" style="width: 100%;">
                </div>
                <div class="p-col-12 p-md-6">
                    <span class="input-label" style="margin-top: 0;">Matrícula</span>
                    <input type="text" pInputText [(ngModel)]="item.matricula" style="width: 100%;">
                </div>
                <div class="p-col-12">
                    <span class="input-label">Telefone / WhatsApp</span>
                    <input pInputText [(ngModel)]="item.telefone" appMascara="telefone" [style]="{'width':'100%'}">
                </div>
                <div class="p-col-12">
                    <span class="input-label">Como podemos ajudar?</span>
                    <textarea pInputTextarea [(ngModel)]="item.mensagem" rows="3" style="width: 100%;" placeholder="Descreva seu problema..."></textarea>
                </div>
            </div>

            <button class="login-btn" (click)="enviarSuporte()">
                Enviar Mensagem <i class="pi pi-send" style="margin-left: 8px;"></i>
            </button>
        </div>

    </div>

    <!-- Diálogo de teste do serviço de WhatsApp (somente após o segredo) -->
    <div class="dev-overlay" *ngIf="testeZapLiberado && exibirTesteZap" (click)="fecharTesteZap()">
        <div class="glass-card dev-dialog" (click)="$event.stopPropagation()">
            <div class="back-link" (click)="fecharTesteZap()">
                <i class="pi pi-times"></i> Fechar
            </div>

            <div class="title" style="font-size: 1.4rem; margin-bottom: 0.3rem;">Teste de WhatsApp</div>
            <div class="subtitle" style="margin-bottom: 1.5rem;">Envio direto pelo serviço de mensagens.</div>

            <div style="text-align: left;">
                <span class="input-label" style="margin-top: 0;">Número (com DDD)</span>
                <input pInputText [(ngModel)]="testeZap.telefone" placeholder="37998552222" style="width: 100%;">

                <span class="input-label">Mensagem</span>
                <textarea pInputTextarea [(ngModel)]="testeZap.mensagem" rows="3" style="width: 100%;"
                    placeholder="Digite a mensagem de teste..."></textarea>
            </div>

            <button class="login-btn" (click)="enviarTesteZap()" [disabled]="enviandoTesteZap">
                {{ enviandoTesteZap ? 'Enviando...' : 'Enviar mensagem' }}
                <i class="pi pi-send" style="margin-left: 8px;" *ngIf="!enviandoTesteZap"></i>
            </button>

            <div class="dev-retorno chamada" *ngIf="chamadaTesteZap">
                <div class="dev-retorno-titulo">
                    <i class="pi pi-upload"></i> Chamada enviada
                </div>
                <pre>{{ chamadaTesteZap }}</pre>
            </div>

            <div class="dev-retorno" *ngIf="retornoTesteZap" [class.erro]="testeZapComErro">
                <div class="dev-retorno-titulo">
                    <i class="pi" [ngClass]="testeZapComErro ? 'pi-times-circle' : 'pi-check-circle'"></i>
                    {{ testeZapComErro ? 'Falha no envio' : 'Envio realizado' }}
                </div>
                <pre>{{ retornoTesteZap }}</pre>
            </div>
        </div>
    </div>
</div>